export default "__VITE_ASSET__c44f1f86__"